import { render, staticRenderFns } from "./NextProject.vue?vue&type=template&id=187adf5a"
import script from "./NextProject.vue?vue&type=script&lang=js"
export * from "./NextProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports